/*	Copyright (c) 1996 - 2026 NoWatt Ltd				*/
/*	  All Rights Reserved  											*/

import React from 'react';

const Footer = () => (
  <nav id="footer">
    <div className="container d-flex justify-content-between align-items-center">
      <div className="fnav">
        <p>
          V5.11 - Copyright&copy; 2005-2026 NoWatt Ltd |{' '}
          <a href="/terms">Terms &amp; Conditions</a>
        </p>
      </div>
      <div className="fnav">
        <ul className="footer-social">
          <li><a href="https://www.linkedin.com/company/nowatt-ltd"><i className="fa fa-linkedin" /></a></li>
          <li><a href="https://www.youtube.com/channel/UCjUU4JZ3dK7Yw8YBvmOYJIQ"><i className="fa fa-youtube" /></a></li>
          <li><a href="https://twitter.com/nowatt_ltd"><i className="fa fa-twitter" /></a></li>
        </ul>
      </div>
    </div>
  </nav>
);

export default Footer;
